<template>
  <section class="grid">
    <h2 class="text-center">{{ $t("navBar.ourBlogs") }}</h2>
    <ul class="row garden-row-none-padding" v-if="blogs">
      <li
        class="col-md-4 col-sm-12"
        v-for="(blog, index) in blogs"
        :key="index"
      >
        <div class="garden-img-full-width">
          <router-link
            :to="{
              name: 'SinglePost',
              params: {
                type: 'blog',
                slug: `${blog.slug}`
              }
            }"
          >
            <img :src="blog.featuredImage" :alt="blog.title" />
          </router-link>
        </div>
        <div class="box">
          <div class="box-content">
            <h3 class="title">
              <router-link
                :to="{
                  name: 'SinglePost',
                  params: {
                    type: 'blog',
                    slug: `${blog.slug}`
                  }
                }"
                >{{ blog.title.substring(0, 70) }}....</router-link
              >
            </h3>
            <p class="text-justify">
              {{ decodeHtml(blog.content) | strippedContent }} {{ "..."
              }}<router-link
                :to="{
                  name: 'SinglePost',
                  params: {
                    type: 'blog',
                    slug: `${blog.slug}`
                  }
                }"
                class="readMore"
              >
                {{ $t("readMore") }}{{ " " }}
              </router-link>
            </p>
          </div>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import moment from "moment";
export default {
  watch: {
    $route() {
      this.getLang();
      this.format_date();
    }
  },
  data() {
    return {
      locale: ""
    };
  },
  filters: {
    strippedContent: function(string) {
      return string.replace(/<\/?[^>]+>/gi, " ").substring(0, 220);
    }
  },
  name: "HomeBlogs",
  methods: {
    getLang() {
      this.locale = this.$i18n.locale;
      this.postArticles = this.articles;
      this.postPagination = this.pagination;
    },
    decodeHtml: function(html) {
      var txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    format_date(value) {
      if (value) {
        if (this.$i18n.locale == "en") {
          return moment(String(value)).format("MM/DD/YYYY");
        } else {
          return moment(String(value)).format("DD/MM/YYYY");
        }
      }
    }
  },
  props: {
    blogs: {},
    type: String
  }
};
</script>
<style scoped lang="scss">
.readMore {
  color: #5bbb2d;
  font-size: 16px;
  font-weight: bold;
  font-style: italic;
}
.readMore:hover {
  color: red;
}
.grid {
  margin: 10px;
  padding: 5px;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
  border-bottom: 5px solid #fff;
  background: #fff !important;
}
.grid ul li {
  margin-bottom: 0px !important;
}
.grid h2 {
  font-size: 30px !important;
  font-weight: bold;
  padding: 20px;
  text-transform: capitalize;
  text-align: center !important;
  color: #5bbb2d !important;
}

.title {
  font-size: 14px !important;
  height: 80px;
  text-align: center !important;
  color: #5bbb2d !important;
}
.title a {
  color: #000 !important;
}
.box {
  /* border: 2px solid red; */
  padding: 0px !important;
  background: #f6faff !important;
}
.grid li .box .box-content {
  padding: 20px !important;
}
.grid li .box .box-content p {
  color: black !important;
  height: 150px;
}

.garden-img-full-width img,
.garden-img-full-width {
  height: 250px;
  object-fit: cover;
}
@media (min-device-width: 320px) and (max-device-width: 480px) {
  .grid ul li {
    margin-bottom: 30px !important;
    padding-bottom: 20px;
  }
}
@media (max-device-width: 320px) {
  .grid ul li {
    margin-bottom: 30px !important;
    padding-bottom: 20px;
  }
  .title {
    font-size: 11px !important;
  }
}
</style>
